import React from 'react'
import styles from './MediaGridPanel.module.scss'

interface MediaGridPanelProps {
  children: React.ReactNode
  className?: never
}

export const MediaGridPanel: React.FC<MediaGridPanelProps> = ({ children }) => (
  <div className={styles.panel}>{children}</div>
)
